import { render, staticRenderFns } from "./CommercialOwnerCmp.vue?vue&type=template&id=7300b118&scoped=true"
import script from "./CommercialOwnerCmp.vue?vue&type=script&lang=js"
export * from "./CommercialOwnerCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7300b118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7300b118')) {
      api.createRecord('7300b118', component.options)
    } else {
      api.reload('7300b118', component.options)
    }
    module.hot.accept("./CommercialOwnerCmp.vue?vue&type=template&id=7300b118&scoped=true", function () {
      api.rerender('7300b118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Add/CommercialOwnerCmp.vue"
export default component.exports